module.exports = __webpack_public_path__ + "img/toplogo.ae4736bf.png";